import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <ShowocaseLayout
    key="/business/showcase/stacking"
    exact
    path="/business/showcase/set"
    component={AsyncPage}
  />,
];
